import { CURRENCIES } from '../../../../configurations/currencies';
import { Currencies } from '../types/currency';

export function getCurrencies(): Currencies {
    return CURRENCIES;
}
